import { Component, Fragment } from 'react';
import {
    Box,
    Collapse,
    Grid
} from '@mui/material';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL


class GameModeSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { value: "" }
        this.id = props.id
    }

    render() {

        const headerWidth = this.props.headerWidth ?? '50%'

        return (
            <Fragment>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 1 }}
                >
                    <img
                        src={`${this.props.gameMode.url}`}
                        sx={{ mt: 3, mb: 2 }}
                        onClick={this.props.toggleGameMode}
                        style={{ width: headerWidth, borderRadius: 12 }}
                        alt='Game Mode Toggle'
                    />
                </Box>
                <Box>
                    <Collapse in={this.props.showGameMode} sx={{ mt: 1 }}>
                        <Grid container justifyContent="center">
                            <Grid item xs={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{ p: 0.5 }}
                                >
                                    <img
                                        src={`${IMAGE_URL}game_modes/Normal.png`}
                                        alt='Normal'
                                        loading="lazy"
                                        value='0'
                                        name='Normal'
                                        style={{ width: "90%", borderRadius: 12 }}
                                        onClick={(event) => this.props.handleGameMode(event)}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{ p: 0.5 }}
                                >
                                    <img
                                        src={`${IMAGE_URL}game_modes/Hardcore.png`}
                                        alt='Hardcore'
                                        loading="lazy"
                                        value='1'
                                        name='Hardcore'
                                        style={{ width: "90%", borderRadius: 12 }}
                                        onClick={(event) => this.props.handleGameMode(event)}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Collapse>
                </Box>
            </Fragment>

        )

    }
}

export default GameModeSelect
